import React, {Component} from 'react';
import {connect} from "react-redux";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';

class ToggleMaxResultBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numberInput: "",
            isNumberInputSelected: false
        };
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.toggleNumberInput = this.toggleNumberInput.bind(this);
        this.updateOptions = this.updateOptions.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.maxResults !== undefined) {
            const maxResult = this.props.clickedNodeInfo.extras.options.maxResults;
            if (maxResult !== "") {
                this.setState({
                    numberInput: maxResult,
                    isNumberInputSelected: true
                });
            }
        }
    }
    handleChangeInput(e){
        this.setState(
            { numberInput: e.target.value },
            () => {
                this.updateOptions();
            }
        );
    }
    toggleNumberInput() {
        this.setState(
            prevState => ({
                isNumberInputSelected: !prevState.isNumberInputSelected}),
            () => {
                if (!this.state.isNumberInputSelected) {
                    this.setState({
                       numberInput: "",
                       isNumberInputSelected: false
                        }, () => {
                        this.updateOptions();
                    });
                } else if (this.state.numberInput === "") {
                    this.setState({
                        numberInput: "500",
                        isNumberInputSelected: true
                        }, () => {
                        this.updateOptions();
                        });
                } else {
                    this.updateOptions();
                }
            });
    }

    updateOptions(){
        const numberInput = this.state.numberInput;
        const isNumberInputSelected = this.state.isNumberInputSelected;
        const clickedNodeInfo = this.props.clickedNodeInfo;
       
        let toggleBoxInfo = Object.assign({}, clickedNodeInfo);
        if(!Object.prototype.hasOwnProperty.call(toggleBoxInfo.extras, "options")){
            toggleBoxInfo.extras.options = {};
        }
        toggleBoxInfo.extras.options.maxResults = numberInput;
        if(!Object.prototype.hasOwnProperty.call(toggleBoxInfo.extras.options, "scoringOptions")){
            toggleBoxInfo.extras.options.scoringOptions = {};
        }
        toggleBoxInfo.extras.options.scoringOptions.maxResults = numberInput;
        toggleBoxInfo.extras.options.scoringOptions.isMaxResultsSelected = isNumberInputSelected;
        this.props.clickedNodeAction(toggleBoxInfo);
    }

    render() {
        return (
            <div className="filter-group">
                <div className="filter-group-header">
                    <label className="checkbox-wrapper">
                        <input type="checkbox" className="checkbox" checked={ this.state.isNumberInputSelected } onChange={ this.toggleNumberInput }/>
                        Maximum Item Count
                    </label>
                </div>
                {this.state.isNumberInputSelected &&
                <div className="filter-group-content">
                    <div className="filter-rule">
                        <div className="input-container">
                            <input name="numberInput" onChange={(e) => this.handleChangeInput(e)} className="number-input" type="number" value={this.state.numberInput}/>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo
    }
}
export default connect(mapStateToProps, {clickedNodeAction})(ToggleMaxResultBox);

